import { baseUrl } from './routes';

export class GalleryRoutes {
  static get base(): string {
    return `${baseUrl}/gallery`;
  }
}
